<template>
    <div>
        
        <!-- <v-item-group v-for="video, idx in videoId" :key="idx">
            <youtube :video-id=video fitParent/>
        </v-item-group> -->

        <v-tabs class="tab tab--inline mb-50 mb-md-70 mb-lg-80" height="18" centered>
            <v-tab class="tab__li" @click="filter.category=''">전체</v-tab>
            <v-tab class="tab__li" @click="filter.category='WORKSHOP'">해외 워크숍</v-tab>
            <v-tab class="tab__li" @click="filter.category='SEMINAR'">국내 세미나</v-tab>
            <v-tab class="tab__li" @click="filter.category='AMBASSADOR'">브랜드 홍보대사</v-tab>
            <v-tab class="tab__li" @click="filter.category='FUND_RASER'">펀드레이저</v-tab>
            <v-tab class="tab__li" @click="filter.category='DAIARY'">일상</v-tab>
        </v-tabs>

        <v-row class="ma-n2">
            <v-col cols="6" md="3" class="pa-2" v-for="photo, idx in boards" :key="idx">
                <div class="thumb-wrap" @click="popup(photo)" style="cursor: pointer">
                    <div class="thumb" :style="`background-image: url(${photo.thumb})`"></div>
                </div>
            </v-col>
        </v-row>

        <div class="mt-50 mt-lg-80">
            <v-pagination v-model="page" :length="pageCount" :total-visible="11" @input="search()" />
        </div>

        <popup ref="modal" :img="img"/>

    </div>
</template>

<script>
import api from "@/api";
import urlParser from "js-video-url-parser";
import Popup from "@/components/client/business/view.vue"

export default {
    components: {
        Popup
    },
    data() {
        return {
            filter: {
                category: null,
                code: "youtube"
            },
            boards: [],
            youtube: [],
            videoId: [],
            img: undefined,
            pageCount: 1,

            page: +this.$route.query.page || 1,

            limit: 12,

            totalCount: 0,

            
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        pageCount() {
            return Math.ceil(this.totalCount / this.limit)
        },
        skip() {
            return (this.page - 1) * this.limit
        },
    },
    methods: {
        async init() {
            await this.search();
        },
        async search() {
            const { page, skip, limit, params } = this;
            let { 
                    summary: { totalCount}, 
                    boards 
                } = await api.v1.boards.gets({ 
                headers: { skip, limit }, 
                params : this.filter });

            this.boards = boards
            this.pageCount = Math.ceil(totalCount / this.limit);
            this.totalCount = totalCount;

            let youtube = await api.v1.boards.gets({ params : { 'code': 'youtube', 'category': 'YOUTUBE' }});
            this.youtube = youtube.boards

            this.videoId = this.youtube.map(video => {
                return urlParser.parse(video.meta.youtube)?.ids
            })
        },
        popup(photo) {
            this.img = photo;
            this.$nextTick(() => {
                this.$refs.modal.open();
            })

        }
    },
    watch: {
        async "filter.category"() {
            this.page = 1
            this.init();

        },
        async page() {
            await this.init()
        },
    }
};
</script>

<style scoped>
.thumb-wrap{
    padding-top: calc((198 / 297) * 100%);
}
</style>

